import { useLanguage } from '../../../contexts/useLanguage';
import screenshotsImg from '../../../assets/readdy/dbe93078d6cdc5e532c1cb129ffdce20__c405a9e29d.png';

export default function Screenshots() {
  const { language } = useLanguage();

  const content = {
    zh: {
      subtitle: 'Screenshots',
      title: '应用截图',
      description: '直观的界面设计，流畅的创作体验',
      feature1Title: '图片生成',
      feature1Desc: '输入创意描述，AI即刻生成精美漫画画面',
      feature2Title: '视频生成',
      feature2Desc: '将静态漫画转化为动态动画短片',
      feature3Title: '分镜',
      feature3Desc: '自由编辑对话和叙事，创作完整故事'
    },
    en: {
      subtitle: 'Screenshots',
      title: 'App Screenshots',
      description: 'Intuitive interface design, smooth creative experience',
      feature1Title: 'Image Generation',
      feature1Desc: 'Input creative descriptions, AI instantly generates beautiful comic visuals',
      feature2Title: 'Video Generation',
      feature2Desc: 'Convert static comics into dynamic animated shorts',
      feature3Title: 'Storyboard',
      feature3Desc: 'Freely edit dialogues and narratives, create complete stories'
    }
  };

  const t = content[language];

  return (
    <section id="screenshots" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <p className="text-xs font-light text-gray-500 tracking-widest uppercase mb-3">
            {t.subtitle}
          </p>
          <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-4">
            {t.title}
          </h2>
          <div className="w-24 h-1 bg-gray-900 rounded-full mx-auto mb-6"></div>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            {t.description}
          </p>
        </div>

        <div className="relative">
          <div className="flex items-center justify-center">
            <img
              src={screenshotsImg}
              alt="AiComic App Screenshots"
              className="w-full max-w-6xl rounded-3xl shadow-2xl"
            />
          </div>
        </div>

        <div className="mt-16 grid md:grid-cols-3 gap-8">
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-gray-900 rounded-2xl mx-auto mb-4">
              <i className="ri-image-add-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">{t.feature1Title}</h3>
            <p className="text-sm text-gray-600">
              {t.feature1Desc}
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-red-600 rounded-2xl mx-auto mb-4">
              <i className="ri-movie-2-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">{t.feature2Title}</h3>
            <p className="text-sm text-gray-600">
              {t.feature2Desc}
            </p>
          </div>
          <div className="text-center">
            <div className="w-16 h-16 flex items-center justify-center bg-gray-700 rounded-2xl mx-auto mb-4">
              <i className="ri-layout-grid-line text-3xl text-white"></i>
            </div>
            <h3 className="text-lg font-bold text-gray-900 mb-2">{t.feature3Title}</h3>
            <p className="text-sm text-gray-600">
              {t.feature3Desc}
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
